/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import { FC, useState } from 'react';
import { Routes, Route, BrowserRouter, Navigate, useNavigate } from 'react-router-dom';
import { PrivateRoutes } from './PrivateRoutes';
import { ErrorsPage } from '../modules/errors/ErrorsPage';
import { Logout, AuthPage, useAuth } from '../modules/auth';
import { App } from '../App';
import { setupInterceptorsTo } from '../core/Interceptors/AxiosInterceptors';
import axios from 'axios';
import { CustomerPanelPage } from '../modules/customer-panel/CustomerPanelPage';
import { WorkOrderLinkPage } from '../modules/work-order-link/WorkOrderLinkPage';
// import {LowStockReportRoutes} from '../modules/lowstockreport/LowStockReportRoutes'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;

function NavigateFunctionComponent() {
  let navigate = useNavigate();
  const { saveAuth, logout } = useAuth();
  const [ran, setRan] = useState(false);

  // only run setup once
  if (!ran) {
    setupInterceptorsTo(axios, navigate, saveAuth, logout);
    setRan(true);
  }
  return <></>;
}

const AppRoutes: FC = () => {
  const { currentUser } = useAuth();
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      {<NavigateFunctionComponent />}
      <Routes>
        <Route element={<App />}>
          <Route path='cp/*' element={<CustomerPanelPage />} />
          <Route path='wo/:key' element={<WorkOrderLinkPage />} />
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          {currentUser ? (
            <>
              <Route path='/*' element={<PrivateRoutes />} />
              <Route index element={<Navigate to='/dashboard' />} />
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path='*' element={<Navigate to='/auth' />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export { AppRoutes };
